import NormalBtn from "components/NewButton/NormalBtn";

const DraftInfoButtons = ({ onClickRetrieve, baseState, onClickSave }) => {
  if (baseState.approval_status === "승인대기") {
    return (
      <>
        <NormalBtn margin="0 0 0 0.5rem" name="회수" onClick={onClickRetrieve} />
      </>
    );
  } else if (
    baseState.approval_status === "임시저장" ||
    baseState.approval_status === "반려" ||
    baseState.approval_status === "회수"
  ) {
    if (baseState.approval_status === "반려" || baseState.approval_status === "회수") {
      return (
        <>
          <NormalBtn margin="0 0 0 0.5rem" name="재기안" onClick={() => onClickSave("재기안")} />
        </>
      );
    } else {
      return <></>;
    }
  }
};
export default DraftInfoButtons;
